export const primaryBlue = "#2D3394";
export const grey50 = "#F2F2F7";
export const white = "#FFFFFF";
export const black = "#000000";
export const black100 = "#121212";
export const black200 = "#272833";
export const black300 = "#293050";
export const grey200 = "#C7C7CC";
export const grey300 = "#535353";
export const grey1000 = "#616161";
export const graphBlue = "#357AF6";
export const calendarBlue = "#D9ECFF";
export const statusGreen = "#58A55C";
export const statusRed = "#A80000";
export const statusYellow = "#E28E51";
export const dividerGrey = "#55565A1F";
export const graphOrange = "#FF7A00";
export const tableRed = "#F26A6A";
export const tableBlue = "#80AAF5";
export const tableGreen = "#99FA91";
export const tableYellow = "#FFC85D";
export const tableColumnBlue = "#F1F6FF";
export const backgroundRed = "#F8D7DA";
export const tableGreenText = "#155724";
export const backgroundGreen = "#D4EDDA";
export const graphDarkBlue = "#255B9A";
